export default __webpack_public_path__ + "static/media/host_hungUp.4908b6e9.svg";